import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { PageTabs, type PageTab } from "@components/CatalogIndex";
import useAccountHasEntitlement from "@common/hooks/useAccountHasEntitlement";
import "./BusinessUnitEditLayout.css";

export const BusinessUnitEditLayout = (): JSX.Element => {
  const { hasEntitlement } = useAccountHasEntitlement();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // Active tab is derived from the sub-route so styling stays correct on direct
  // navigation/refresh, not just clicks.
  const activeKey = pathname.includes("/special_conditions")
    ? "special_conditions"
    : "business_unit";

  const tabs: PageTab[] = [
    { key: "business_unit", label: "Business Unit" },
    ...(hasEntitlement("terms-and-conditions")
      ? [{ key: "special_conditions", label: "Terms & Conditions" }]
      : []),
  ];

  // Route-relative navigation resolves against this layout's route (`:id`).
  const handleSelect = (key: string) =>
    navigate(key === "business_unit" ? "edit" : key);

  return (
    <div className="business-unit-edit-layout">
      <PageTabs activeKey={activeKey} onSelect={handleSelect} tabs={tabs} />
      <Outlet />
    </div>
  );
};

export default BusinessUnitEditLayout;
